import { render, staticRenderFns } from "./border-style.vue?vue&type=template&id=e8f3ac62&scoped=true&"
var script = {}
import style0 from "./border-style.vue?vue&type=style&index=0&id=e8f3ac62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f3ac62",
  null
  
)

export default component.exports